module.exports = __webpack_public_path__ + "img/5visa_PNG30.ac9efeeb.png";